import {
  BotType,
  PaperBtcUsdt,
  PaperExchange,
  StoplossType,
  DcaType,
  DcaTime,
  WeekTime,
  TakeProfitType,
} from "../../../../Const";

export const adaptBotDefault = (
  exchange = PaperExchange,
  exchangePair = {}
) => {
  const pair = exchangePair.pair || {};
  return {
    id: null,
    name: "New Bot",
    exchange: exchange,
    exchangePairId: exchangePair.id, //exchange_pair.id
    pair: exchangePair.pair,
    strategy: "Long",
    initFund: 0,
    baseOrderType: "static",
    tradeOrderType: "market",
    tradeOrderTypeExit: "market",
    baseOrder: 50, //%
    extraOrderNum: 2, //%
    frequency: 15,
    takeProfit: 0,
    stoploss: 0,
    timeFrame: 365,
    entryNum: 0,
    exitNum: 0,
    entryIndicators: [],
    exitIndicators: [],
    tvAlertsEntry: [],
    tvAlertsExit: [],
    baseCoin: pair.from,
    quoteCoin: pair.to,
    applyCurrentDeal: false,
    closeBotAfterDeal: 0,
    stoplossType: StoplossType.absolute,
    variableTSL: [{ id: null, triggerAt: 2, stopAt: 1 }],
    fixedTSL: { id: null, triggerAt: 2, stopAt: 1 },
    takeProfitType: TakeProfitType.absolute,
    variableTP: [{ id: null, triggerAt: 2, stopAt: 1 }],
    fixedTP: { id: null, triggerAt: 2, stopAt: 1 },
    minTp: 0,
    botType: BotType.simple,
    dcaType: DcaType.time,
    dcaTime: {
      type: DcaTime.daily,
      weekValue: WeekTime.mon,
      monthValue: "1",
    },
    dcaPercent: "2",
    dcaTrigger: "0",
    dcaExit: 0,
    dcaNoLimitFund: false,
    dcaOrder: "100",
    dcaMartingale: 0,
    entryPrice: '',
    entryPriceCondition: '',
    gridRangeKlineDirection: 0,
    gridEntryType: "imd",
    gridExitStrategyNoTrade: "cancel_restart",
    gridExitStrategyHasTrade: "cancel_restart",
    gridUpperRange: "",
    gridLowerRange: "",
    gridOrderNum: "",
    gridOrderVol: "",
    gridExitWaitTime: 0,
    gridExitOuterRange: 0,
    tvAlertEntryStatus: false,
    tvAlertExitStatus: false,
    tvAlerts: [],
    avgEntryPrice:0,
    sellPrice:0,
    sellStopLoss:0,
    stopBotAfterDeal: 0,
    closeDealEndOfTradingDay: 0,
    daisyChain:0,
    firstInDaisyChain:0,
    minPriceGapProfit:0,
    isEditing:false,
    extendedTradingHour:0,
    tradingHour247:0,
    disableFractionPurchase:0,
    is247:exchangePair.is_247,
    backtestCustom: false,
    backTestStart: new Date().getTime(),
    backTestEnd: new Date().getTime(),
    basePriceGapMin:"",
    extraPriceGapMin:"",
    sendOrderFilledEmail:1,
    sendOrderFilledPhone:0
  };
};
